<template>
  <div>
        <!--<div style="width: 100%; display: flex; flex-direction: row;">
          <div style="display: flex; flex-direction: column; margin-left: 20px;">
            <span>
                Stroke Action
            </span>
          
          <button type="button" @click.prevent="toggleEraser" style="width: 100px; height: 30px;">
            <span v-if="eraser">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eraser" viewBox="0 0 16 16">
                <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>
              </svg>
              Eraser
            </span>
            <span v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
              </svg>
              Draw
            </span>
          </button>
          </div>
          <div style="display: flex; flex-direction: column; margin-left: 20px;">
            <span>
                Stroke Width
            </span>
            <el-select v-model="line" size="small">
                <el-option v-for="n in 25" :key="'option-' + n" :value="n">{{ n }}</el-option>
            </el-select>
          </div>
          <div style="display: flex; flex-direction: column; margin-left: 20px;">
            <span>
                Stroke Color
            </span>          
          <input type="color" v-model="color">  
          </div>        
        </div>
        <br><br>-->
      
      <el-button type="primary" size="small" @click="$refs.VueCanvasDrawing.undo()">
        Undo
      </el-button>
      <br><br>  
      <div 
        @click="convertImage" 
        :id="'wo_canvas_container_'+sale_item_index+'_'+workOrderData.sub_sl_no"
        :style="{border: '1px solid #383838', width: (getScreenWidth-100), height: (getScreenHeight-100)}">
        <vue-drawing-canvas
          :canvasId="'wo_canvas_'+sale_item_index+'_'+workOrderData.sub_sl_no"
          ref="VueCanvasDrawing"
          :v-model="image"
          :stroke-type="'dash'"
          :fill-shape="false"
          :eraser="getEraser"
          :lineWidth="line"
          :lineCap="'round'"
          :lineJoin="'miter'"
          
          :color="getColor"
          :width="(getScreenWidth-200)"
          :height="(getScreenHeight)"
          :background-color="backgroundColor"
          :background-image="backgroundImage"
          saveAs="jpeg"
          :styles="{
            'border': 'solid 1px #000'
          }"
          :lock="false"
          
        />
        
      </div>
      
    </div>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";
export default {
   props: ['workOrderData', 'sale_item_index'], 
  components: {
    VueDrawingCanvas,
  },
  data() {
    return {
      image: this.workOrderData.sketch,
      eraser: false,
      line: 1,
      color: '#000000',
      strokeType: 'dash',
      backgroundColor: '#FFFFFF',
      backgroundImage: this.workOrderData.tailoring_flat_image
    }
  },
  computed: {
    getEraser() {
      return this.eraser
    },
    getColor() {
      return this.color
    },
    getScreenWidth() {
        return window.screen.width
    },
    getScreenHeight() {
        return window.screen.height
    }
  },
  methods: {
    toggleEraser() {
      this.eraser = !this.eraser
      if(!this.getEraser) {
        this.color = 'black'
      }      
    },
    async setImage(event) {
      let URL = window.URL;
      this.backgroundImage = URL.createObjectURL(event.target.files[0]);
      await this.$refs.VueCanvasDrawing.redraw();
    },
    convertImage() {
        
        var can = document.getElementById('wo_canvas_'+this.sale_item_index+'_'+this.workOrderData.sub_sl_no);
        var ctx = can.getContext('2d');

        ctx.fillRect(50,50,50,50);

        var img = new Image();
        img.src = can.toDataURL();
        this.image = img.src
        this.workOrderData.sketch = this.image
    }
  },
  mounted() {
    setTimeout(() => {
        
        if(this.workOrderData.sketch.length === 0) {
            if(this.workOrderData.tailoring_flat_image.length === 0) {
               this.backgroundImage = null
            }
        } else {
            this.backgroundImage = this.workOrderData.sketch
        }
        
    }, 400);
  }
};
</script>

<style scoped>
  .button-container {
    display: flex;
    flex-direction: row;
  }
  .button-container > * {
    margin-top: 15px;
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Whiteboard.vue